// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "label-1uxWc";
var _3 = "active-Xejl3";
var _4 = "radio-thIxu";
export { _1 as "__esModule", _2 as "label", _3 as "active", _4 as "radio" }
export default { "__esModule": _1, "label": _2, "active": _3, "radio": _4 }
